import { render, staticRenderFns } from "./AppointmentPropRegister.vue?vue&type=template&id=50a07f1c&scoped=true&"
import script from "./AppointmentPropRegister.vue?vue&type=script&lang=js&"
export * from "./AppointmentPropRegister.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentPropRegister.vue?vue&type=style&index=0&id=50a07f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a07f1c",
  null
  
)

export default component.exports